export enum QueryKey {
  EntrataSession = 'entrata-session',
  UseApplication = 'use-application',
  UseApplications = 'use-applications',
  UserProperties = 'use-properties',
  AllActiveProperties = 'all-active-properties',
  CompanyIdentificationTypes = 'company-identification-types',
  UserSubsidyPrograms = 'use-subsidy-programs',
  /** Subsidy list from `GET /properties/:clientId/subsidy-programs` (per-client mock / LJ data). */
  UserSubsidyProgramsForClient = 'use-subsidy-programs-for-client',
  UsePropertiesRoutesAndApplications = 'use-properties-routes-and-applications',
}
